import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "leftMenu" }
const _hoisted_3 = { class: "content-cont" }
const _hoisted_4 = { class: "content" }

import { computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import InteractionMode from '@/components/widget/InteractionMode.vue';
  import LeftMenu from '@/components/nav/LeftMenu.vue';
  import { useSubjectStore } from '@/store/subjectStore';
  import { onKeycloakReady } from '@/plugins/keycloak';
  import AppBreadcrumbs from '@/components/widget/AppBreadcrumbs.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const subjectStore = useSubjectStore();
  const route = useRoute();
  const isLandingPage = computed(() => route.path.includes('/landing'));

  onMounted(async () => {
    await onKeycloakReady();
    await subjectStore.fetchSelectedSubject();
  });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (isLandingPage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createBlock(_component_v_main, {
            key: 1,
            class: "mainContainer"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(LeftMenu)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(InteractionMode),
                _createVNode(AppBreadcrumbs),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_view)
                ])
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})